import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import * as S from 'src/modules/programs/stepComponents/styles';
import { color, font } from 'src/shared/styles/variables';

import { PlannedActivity } from '../models/weekThree';
import { getPlannedActivities } from '../selectors/weekThreeSelectors';

const ActivityTitle = styled('span')(
    {
        textTransform: 'capitalize',
        color: color.mariner,
    },
    font.book(font.size.base),
);

interface StateProps {
    plannedActivities: PlannedActivity[];
}

const ActivitiesReminderContainer: React.SFC<StateProps> = ({ plannedActivities }) => (
    <>
        {plannedActivities.map(activity => (
            <S.PlannedActivity key={activity.title}>
                <S.ActivityName>{activity.additionalTitle || activity.title}</S.ActivityName>
                <S.ActivityDescription>
                    <ActivityTitle>{activity.domainTitle}</ActivityTitle>{' '}
                    {activity.dateToBePerformed.format('DD.MM.YYYY, [at] h:mm A')}
                </S.ActivityDescription>
            </S.PlannedActivity>
        ))}
    </>
);

const mapStateToProps = (state: AppState): StateProps => ({
    plannedActivities: getPlannedActivities(state),
});

export const ActivitiesReminder = connect(mapStateToProps)(ActivitiesReminderContainer);
